import axios from '@/utils/axios';

export async function UploadDedicationImage(
  slug: string
) {
  const { data } = await axios.post(
    `${process.env.NEXT_PUBLIC_API_URL}/dedication-image/${slug}`,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return data;
}

export async function GetDedicationImage(key: string) {
  const { data } = await axios.post(
    `${process.env.NEXT_PUBLIC_API_URL}/dedication-image-view`,
    { key },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
}


// new endpoint 
export async function GetDedicationImageURL(
  slug: string
) {
  const { data } = await axios.post(
    `${process.env.NEXT_PUBLIC_API_URL}/dedication-image/${slug}`,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return data;
}

export async function GetProcessedUrl(uploadedKey: string) {
  const { data } = await axios.post(
    `${process.env.NEXT_PUBLIC_API_URL}/dedication-image-process/`,
    {
      uploadedKey, // matches Postman body
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return data;
}
